import { useLingui } from '@lingui/react/macro';
import { openChatwoot } from '@/base/chatwoot';
import { BASE_URL } from '@/base/constants';

export const useExternalLinks = () => {
  const { i18n } = useLingui();
  return {
    support: () => void openChatwoot(),
    supportEmail: 'support@iqx.io',
    helpCenter: `${BASE_URL}/${i18n.locale}/guide`,
    faq: `${BASE_URL}/${i18n.locale}/faq`,
    privacyPolicy: `${BASE_URL}/${i18n.locale}/privacy-policy`,
    termsOfUse: `${BASE_URL}/${i18n.locale}/terms-of-use`,
    telegram: 'https://t.me/iqxexchange',
    linkedin: 'https://linkedin.com',
    instagram: 'https://instagram.com/iqxexchange',
    twitter: 'https://x.com/IQX_Exchange',
    authenticatorAndroid:
      'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pli=1',
    authenticatorIos:
      'https://apps.apple.com/us/app/google-authenticator/id388497605',
    blog: `${BASE_URL}/blog`,
  };
};
